import api from "@/api"

export function getCarousel() {
  return api.get("/index/adList");
}
